<template>
  <div>
   <b-form @submit="onSubmit" @reset="onReset">
   <div class="clearfix">
      <h3 class="underline pb-2">
        Genre
        <span v-if="!insertMode">
        <b-button v-if="!editMode" :pressed.sync="editMode" variant="default" class="profile_button float-right">
          <span class="bi-pencil" aria-hidden="true"></span>
        </b-button>
        <b-button v-if="editMode" type="reset" :pressed.sync="editMode" @click="resetUser" size="sm" variant="danger" class="float-right">
        abbrechen
        </b-button>
       <b-button v-if="editMode" type="button" @click="updateFilme" size="sm" variant="primary" class="float-right ml-3 mr-3">
        speichern
        </b-button>
        </span>
      </h3>
    <b-form-select :disabled="editMode || insertMode" v-model="form.genreid" @change="switchGenre">
       <option v-for="(genre, id) in genres"  v-bind:key="id" :value="genre.id">{{genre.name}}</option>
    </b-form-select>
    </div>

    <div v-if="!editMode" class="clearfix pt-3">
        <b-button v-if="!insertMode" type="button" :pressed.sync="insertMode" size="sm" variant="primary" class="float-right"
          aria-label="Left Align">
          neuer Eintrag
        </b-button>
        <b-button v-if="insertMode" type="reset" :pressed.sync="insertMode"  size="sm" variant="danger" class="float-right">
        abbrechen
        </b-button>
       <b-button v-if="insertMode" type="submit" size="sm" variant="primary" class="float-right ml-3 mr-3">
        speichern
        </b-button>
    </div>

   <div v-if="insertMode">
   <div class="row">
    <div class="col-xs-12 col-md-8">
    <b-form-group
        id="input-group-1"
        label="Titel"
        label-for="input-1">
         <b-form-input id="input-1" v-model="form.titel" type="text" required placeholder="Den Titel eingeben..."/>
    </b-form-group>
    </div>
     <div class="col-xs-12 col-md-4">
      <b-form-group
          id="input-group-14"
          label="Sendereihe"
          label-for="input-14">
            <b-form-select
              id="input-14"
              v-model="form.sendereiheid">
              <option :value="0">Ohne Sendereihe</option>
              <option v-for="(sendung, id) in sendereihen" v-bind:key="id" :value="sendung.id">{{sendung.name}}</option>
            </b-form-select>
      </b-form-group>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12 col-md-2">
      <b-form-group
          id="input-group-11"
          label="Jahr"
          label-for="input-11">
            <b-form-select
              id="input-11"
              v-model="form.jahr"
              required>
              <option v-for="(year, id) in yearValues"  v-bind:key="id" :value="year">{{year}}</option>
            </b-form-select>
      </b-form-group>
    </div>
    <div class="col-xs-12 col-md-2">
      <b-form-group
          id="input-group-12"
          :label="lenGroupLabel"
          label-for="input-12">
          <b-input-group >
          <b-form-input  id="input-12" v-model="form.laenge" required list="laenge-list-id"></b-form-input>
          <datalist id="laenge-list-id">
               <option v-for="laenge in laengeValues" v-bind:key="laenge">{{laenge}}</option>
          </datalist>
          <b-form-select v-model="form.lenTyp" :options="len_options"></b-form-select>

          </b-input-group>
      </b-form-group>
    </div>
    <div class="col-xs-12 col-md-4">
      <b-form-group
          id="input-group-13"
          label="Kategorie"
          label-for="input-13">
            <b-form-select
              id="input-13"
              v-model="kategorie"
              @change="switchSender"
              required>
              <option v-for="(sk, id) in categories" v-bind:key="id" :value="sk.id">{{sk.name}}</option>
            </b-form-select>
      </b-form-group>
    </div>
    <div class="col-xs-12 col-md-4">
      <b-form-group
          id="input-group-14"
          :label="senderLabel"
          label-for="input-14">
            <b-form-select
              id="input-14"
              @change="switchSendereihen"
              v-model="form.senderid"
              required>
              <option v-for="(sender, id) in senderListe" v-bind:key="id" :value="sender.id">{{sender.name}}</option>
            </b-form-select>
      </b-form-group>
    </div>
  </div>
  </div>

<div class="pt-3">
<b-alert :show="filmografie.length===0">keine Einträge</b-alert>
</div>

<div v-for="(filme, index) in filmografie" :key="index">
   <h3 class="underline">
      {{filme[0].jahr}}
   </h3>
    <ul class="list-group pb-3" v-for="(film) in filme" :key="film.id">
    <FilmografieEntry :user="user" :profil="profil" :film="film" :editMode="editMode"/>
    </ul>
</div>

  </b-form>
  </div>
</template>

<script>
import utils from '@/utilities'
import api from '@/api/benutzer'
import FilmografieEntry from './FilmografieEntry'

export default {
  name: 'ProfilFilmografie',
  props: ['user', 'profil'],
  components: {FilmografieEntry},
  watch: {
    // wenn der user manchmal erst geladen wird müssen schauen wann das neue user object kommt
    user: function (newUser, oldUser) {
      this.updateItems(newUser)
    }
  },
  mounted () {
    this.updateItems(this.$props.user)
  },
  methods: {
    showLaenge (film) {
      return film.laenge.endsWith('min') ? film.laenge : film.laenge + 'min'
    },
    async removeFilm (id) {
      if (confirm('Wollen Sie diesen Eintrag entfernen?')) {
        await api.deleteFilm(this.user.id, id)
        let user = await api.get(this.user.id)
        this.$bubble('userchanged', user)
      }
    },
    findSender (senderid) {
      for (let senderCat in this.$store.state.auth.baseData.sender) {
        for (let i = 0; i < this.$store.state.auth.baseData.sender[senderCat].length; i++) {
          if (this.$store.state.auth.baseData.sender[senderCat][i].id === senderid) {
            return this.$store.state.auth.baseData.sender[senderCat][i]
          }
        }
      }
      return {name: 'unbekannter Sender', id: 0}
    },
    updateItems (user) {
      if (user) {
        // tja, jetzt wärs halt cool man könnte über maps iterieren, weil wir das aber erst ab vue 3.x
        // können müssen wir uns jetzt einen abbbrechen um die filme nach jahr zu groupieren
        // erst alles in nen array stopfen, dann reduce und dann sortiren nach länge des ziel array
        // in der schleife holen wir dann das jahr aus dem ersten element
        let filmografie = []
        if (user.filmografie) {
          let tmp = user.filmografie.filter(this.filterGenre)
          for (let i = 0; i < tmp.length; i++) {
            let items = filmografie[tmp[i].jahr]
            if (!items) {
              items = []
            }
            items.push(tmp[i])
            items.sort((a, b) => a.titel.localeCompare(b.titel))
            filmografie[tmp[i].jahr] = items
          }
          this.filmografie = filmografie.filter(a => a != null).sort((a, b) => b[0].jahr - a[0].jahr)
        }
      }
    },
    filterGenre (film) {
      // this check need to be ==
      // eslint-disable-next-line
      return film.genreId == this.form.genreid
    },
    switchGenre () {
      this.updateItems(this.$props.user)
    },
    switchSender () {
      if (this.kategorie) {
        this.senderListe = this.$store.state.auth.baseData.sender[this.kategorie]
        if (this.categories[this.kategorie]) {
          this.senderLabel = this.categories[this.kategorie].senderLabel
        }
      } else {
        this.senderListe = []
      }
    },
    findGenre (genreid) {
      for (let i = 0; i < this.genres.length; i++) {
        // eslint-disable-next-line
        if (this.genres[i].id == genreid) {
          return this.genres[i]
        }
      }
      return {}
    },
    switchSendereihen () {
      let genre = this.findGenre(this.form.genreid)
      if (this.form.senderid) {
        this.sendereihen = this.$store.state.auth.baseData.sendungen.filter(sendung => (sendung.formatId === genre.formatId && sendung.senderId === this.form.senderid))
      } else {
        this.sendereihen = []
      }
    },
    async updateFilme (event) {
      if (this.editMode) {
        let result = await api.updateFilm(this.user.id, this.filmografie)
        let error = result['errorMessage'] ? result['errorMessage'] : (result['errors'] ? result['errors']['errorMessage'] : null)

        if (!error) {
          this.editMode = false
          let user = await api.get(this.user.id)
          this.$bubble('userchanged', user)
          this.form = {'titel': '', 'genreid': this.form.genreid, 'sendereiheid': null}
          this.kategorie = null
          utils.makeToast(this, 'Gespeichtert!', 'success')
        } else {
          utils.makeToast(this, error, 'danger')
        }
      }
    },
    async onSubmit (event) {
      event.preventDefault()
      if (!this.editMode && !this.insertMode) {
        return
      }
      if (this.insertMode) {
        let httpForm = new FormData()
        for (let [key, value] of Object.entries(this.form)) {
          httpForm.append(key, value)
        }
        let result = await api.addFilm(this.user.id, httpForm)
        let error = result['errorMessage'] ? result['errorMessage'] : (result['errors'] ? result['errors']['errorMessage'] : null)
        if (!error) {
          this.insertMode = false
          let user = await api.get(this.user.id)
          this.$bubble('userchanged', user)
          this.form = {'titel': '', 'genreid': this.form.genreid, 'sendereiheid': 0}
          this.kategorie = null
          utils.makeToast(this, 'Gespeichtert!', 'success')
        } else {
          utils.makeToast(this, error, 'danger')
        }
      }
    },
    async resetUser (event) {
      let user = await api.get(this.user.id)
      this.$bubble('userchanged', user)
    },
    onReset (event) {
      event.preventDefault()
      // Reset our form values
      this.form = []
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    categorySort (c1, c2) {
      let w1 = c1.weight
      let w2 = c2.weight
      return w1 - w2
    },
    filtered ($cats) {
      let cats = []
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(this.$store.state.auth.baseData.senderCategories)) {
        if (value.anzeigenFilmografie) {
          cats.push(value)
        }
      }
      return cats.sort(this.categorySort)
    }
  },
  computed: {
    lenGroupLabel () {
      switch (this.form.lenTyp) {
        case 'min':
          return 'Länge'
        case 'items':
          return 'Anzahl'
        default:
          return 'Eingabe erforderlich'
      }
    }
  },  
  data () {
    return {
      senderLabel: 'Sender',
      genres: this.$store.state.auth.baseData.genres,
      editMode: false,
      insertMode: false,
      senderListe: [],
      kategorie: null,
      sendereihen: [],
      categories: this.filtered(this.$store.state.auth.baseData.senderCategories),
      laengeValues: utils.laengeValues(),
      yearValues: utils.yearValues(),
      filmografie: [],
      len_options: ['min', 'items'],
      form: {'genreid': 1, 'titel': '', 'sendereiheid': 0}
    }
  }
}
</script>

<style scoped>
.list-bg {
  background-color: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/main/vue/components/profil/Filmografie.vue